/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from 'react'
import {
  View,
  Platform,
  TouchableOpacity,
  KeyboardAvoidingView,
  ScrollView,
  Text as RNText,
  Dimensions,
  Pressable,
} from 'react-native'
import PropTypes from 'prop-types'
import { selectContactPhone } from 'react-native-select-contact'
import {
  check,
  request,
  openSettings,
  PERMISSIONS,
  RESULTS,
} from 'react-native-permissions'

import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager'
import { Icon, VFInput, VFScreen, Card, VFButton, VFText } from '@vfgroup-oneplatform/foundation/Components'
import { Colors, Images, LightThemeColors, withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

import VfText from '../../Components/VfText'
import HorizontalLine from '../../Components/HorizontalLine'

import { getThemeImages, getThemeColors } from '../../Themes/Modes'

import images from '../../Themes/Images'

import styles from './CallMeBack.Styles'

import { useSafeAreaInsets } from 'react-native-safe-area-context'

import Modal from 'react-native-modal'

const activeScreens = {
  home: 'home',
  error: 'error',
  success: 'success',
}


function CardContent({
  inputRef,
  selectContact,
  phoneNumber,
  setPhoneNumber,
  isPhoneNumberError,
  description,
  loading = false,
  theme,
  checkPhoneNumber,
}) {

  const themeImages = getThemeImages(theme.name)
  const insets = useSafeAreaInsets()

  return (
    <Card
      type='main'
      hasShadow
      theme={theme}
      style={styles.card}
    >
      <View style={styles.cardHeader}>
        <Icon
          name={themeImages.ic_mobile}
          size={30}
          resizeMode="contain"
          type="image"
          style={styles.mobileIcon}
        />
        <View>
          <VfText
            i18nKey="call_me_back_contacts"
            size="h4"
            weight="bold"
            color={theme.colors.textColor}
          />
          <VfText
            i18nKey="call_me_back_send_request"
            color={theme.colors.textColor}
          />
        </View>
      </View>
      <HorizontalLine style={styles.line(theme)} />
      <View style={styles.contactContainer}>
        <VFInput
          fieldRef={ref => {
            inputRef.current = ref
          }}
          label="call_me_back_mobile_no"
          value={phoneNumber}
          onChangeText={setPhoneNumber}
          baseColor={isPhoneNumberError ? theme.colors.textInput.error.baseColor : theme.colors.textInput.default.baseColor}
          tintColor={getThemeColors(theme.name).tintColor}
          // showLatestPhoneNumbers={true}
          containerStyle={styles.inputContainer}
          labelTextStyle={styles.inputText(theme)}
          style={styles.inputText(theme)}
          keyboardType="phone-pad"
          showHelperText={isPhoneNumberError}
          helperTextColor={theme.colors.textInput.error.baseColor}
          helperText="call_me_back_wrong_phone_format"
          editable={!loading}
          onBlur={checkPhoneNumber}
        />
        {/* <TouchableOpacity
          style={styles.selectContactBtn}
          onPress={selectContact}
          disabled={loading}
        >
          <Icon
            name={images.contacts_white}
            size={40}
            resizeMode="contain"
            type="image"
          />
        </TouchableOpacity> */}

      </View>
      <HorizontalLine style={styles.line(theme)} />
      <VfText
        i18nKey={`*${description}` || ''}
        color={theme.colors.textColor}
        style={styles.text}
      />
    </Card>
  )
}
CardContent.propTypes = {
  inputRef: PropTypes.object,
  selectContact: PropTypes.func,
  phoneNumber: PropTypes.string,
  setPhoneNumber: PropTypes.func,
  checkPhoneNumber: PropTypes.func,
  isPhoneNumberError: PropTypes.bool,
  description: PropTypes.string,
  loading: PropTypes.bool,
  theme: PropTypes.object,
}

function Home({
  onClose,
  navigateToHistory,
  changeActiveScreen,
  dailyRequest,
  inputRef,
  selectContact,
  phoneNumber,
  setPhoneNumber,
  checkPhoneNumber,
  isPhoneNumberError,
  setPhoneNumberError,
  validityObject,
  userPhoneNumber,
  callMeBack,
  callMeBackLoading,
  loading,
  getHistory,
  theme,
  formatPhoneNumber,
  setModalScreen,
  setIsModalVisible
}) {
  // const { addPhoneNumber } = usePhoneNumbers()
  const confirm = async () => {
    if (!isPhoneNumberError) {
      const receiverNumber = formatPhoneNumber(phoneNumber)
      callMeBack(receiverNumber, {
        onSuccess: () => {
          getHistory()
          if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
            setModalScreen(activeScreens.success)
            setIsModalVisible(true)
          } else {
            changeActiveScreen(activeScreens.success)
          }
        },
        onError: () => {
          if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
            setModalScreen(activeScreens.error)
            setIsModalVisible(true)
          } else {
            changeActiveScreen(activeScreens.error)
          }
        },
      })
      // addPhoneNumber('callMeBack', phoneNumber, userPhoneNumber)
    }
  }

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      // <SafeAreaView
      //   style={styles.container}
      //   edges={['right', 'left', 'bottom']}
      // >
      <VFScreen
        title="call_me_back_title"
        onClose={onClose}
        withSubHeader
        subHeaderTitle={userPhoneNumber}
        subHeaderTitleStyle={styles.titleStyle}
        subHeaderSubTitle={dailyRequest.toString() + '/' + validityObject?.['remainingperday']?.value.toString()}
        subHeaderSubTitleStyle={styles.subtitleStyle}
        subHeaderAfterSubTitle="call_me_back_daily_request"
        subHeaderAfterSubTitleStyle={styles.afterSubtitleStyle}
        renderSubHeaderRightComponent={() => {
          return (
            <TouchableOpacity
              style={styles.subheaderRightContainer}
              onPress={navigateToHistory}
              disabled={loading}
            >
              <VfText
                i18nKey="call_me_back_history_btn"
                size="footnote"
                color={Colors.vfRed}
              />
              <Icon
                name={images.history}
                type="image"
                size={20}
                resizeMode="contain"
                style={styles.subheaderRightIcon}
              />
            </TouchableOpacity>
          )
        }}
      >
        <KeyboardAvoidingView
          style={styles.container}
          behavior={Platform.select({
            ios: 'padding',
            android: undefined,
          })}>
          <VfText
            i18nKey="call_me_back_select_recipiant"
            size="h3"
            color={theme.colors.textColor}
            weight="bold"
            style={styles.selectRecipiantText}
          />
          <RNText
            style={styles.serviceDescription(theme)}
          >
            <RNText>{ContentManager.translate('call_me_back_service_description')}</RNText>
            <RNText style={styles.serviceAmount} >{ContentManager.translate('call_me_back_service_amount')}</RNText>
          </RNText>

          <CardContent
            inputRef={inputRef}
            selectContact={selectContact}
            phoneNumber={phoneNumber}
            setPhoneNumber={setPhoneNumber}
            checkPhoneNumber={checkPhoneNumber}
            isPhoneNumberError={isPhoneNumberError}
            setPhoneNumberError={setPhoneNumberError}
            description={validityObject?.['remainingpermonth']?.description}
            loading={loading}
            theme={theme}
          />
          <VFButton
            type="primary"
            title="call_me_back_confirm"
            onPress={confirm}
            style={styles.button}
            disabled={!phoneNumber || isPhoneNumberError || callMeBackLoading || loading}
            isLoading={callMeBackLoading}
            disabledStyle={styles.disabledButton(theme)}
          />

        </KeyboardAvoidingView>
      </VFScreen>
      // </SafeAreaView>
    )
  }


  return (
    <VFScreen
      title="call_me_back_title"
      onClose={onClose}
      withSubHeader
      // withHeaderSpace
      subHeaderTitle={userPhoneNumber}
      subHeaderTitleStyle={styles.titleStyle}
      subHeaderSubTitle={dailyRequest.toString() + '/' + validityObject?.['remainingperday']?.value.toString()}
      subHeaderSubTitleStyle={styles.subtitleStyle}
      subHeaderAfterSubTitle="call_me_back_daily_request"
      subHeaderAfterSubTitleStyle={styles.afterSubtitleStyle}
      renderSubHeaderRightComponent={() => {
        return (
          <TouchableOpacity
            style={styles.subheaderRightContainer}
            onPress={navigateToHistory}
            disabled={loading}
          >
            <VfText
              i18nKey="call_me_back_history_btn"
              size="footnote"
              color={Colors.vfRed}
            />
            <Icon
              name={images.history}
              type="image"
              size={20}
              resizeMode="contain"
              style={styles.subheaderRightIcon}
            />
          </TouchableOpacity>
        )
      }}
    >
      <KeyboardAvoidingView
        style={styles.container}
        behavior={Platform.select({
          ios: 'padding',
          android: undefined,
        })}>
        <ScrollView contentContainerStyle={styles.contentContainer}>
          <VfText
            i18nKey="call_me_back_select_recipiant"
            size="h3"
            color={theme.colors.textColor}
            weight="bold"
            style={styles.selectRecipiantText}
          />
          <RNText
            style={styles.serviceDescription(theme)}
          >
            <RNText>{ContentManager.translate('call_me_back_service_description')}</RNText>
            <RNText style={styles.serviceAmount} >{ContentManager.translate('call_me_back_service_amount')}</RNText>
          </RNText>

          <CardContent
            inputRef={inputRef}
            selectContact={selectContact}
            phoneNumber={phoneNumber}
            setPhoneNumber={setPhoneNumber}
            checkPhoneNumber={checkPhoneNumber}
            isPhoneNumberError={isPhoneNumberError}
            setPhoneNumberError={setPhoneNumberError}
            description={validityObject?.['remainingpermonth']?.description}
            loading={loading}
            theme={theme}
          />
        </ScrollView>

        <VFButton
          type="primary"
          title="call_me_back_confirm"
          onPress={confirm}
          style={styles.button}
          disabled={!phoneNumber || isPhoneNumberError || callMeBackLoading || loading}
          isLoading={callMeBackLoading}
          disabledStyle={styles.disabledButton(theme)}
        />

      </KeyboardAvoidingView>
    </VFScreen>
  )
}
Home.defaultProps = {
  dailyRequest: 2,
  validityObject: {
    remainingpermonth: {
      description: 'Call me back service',
    },
  },
}
Home.propTypes = {
  onClose: PropTypes.func,
  navigateToHistory: PropTypes.func,
  changeActiveScreen: PropTypes.func,
  dailyRequest: PropTypes.number,
  inputRef: PropTypes.object,
  selectContact: PropTypes.func,
  phoneNumber: PropTypes.string,
  setPhoneNumber: PropTypes.func,
  checkPhoneNumber: PropTypes.func,
  isPhoneNumberError: PropTypes.bool,
  setPhoneNumberError: PropTypes.func,
  validityObject: PropTypes.object,
  userPhoneNumber: PropTypes.string,
  callMeBack: PropTypes.func,
  callMeBackLoading: PropTypes.bool,
  loading: PropTypes.bool,
  getHistory: PropTypes.func,
  theme: PropTypes.object,
}


function ErrorStep({
  returnToHome,
  callMeBackError,
  theme,
}) {

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <View style={styles.successContainer(theme)}>
        <ScrollView contentContainerStyle={styles.scrollViewContent}>
          <Icon
            name={Images.ic_WarningHiLight_Theme}
            size={120}
            resizeMode="contain"
            type="image"
            style={styles.image}
          />
          <View style={styles.textContainer}>
            <VfText
              i18nKey="call_me_back_error_title"
              size="h1"
              weight="bold"
              color={theme.colors.textColor}
            />
            <VfText
              i18nKey={callMeBackError || 'call_me_back_default_error'}
              size="h5"
              color={theme.colors.textColorTwo}
              style={styles.description}
            />
          </View>
        </ScrollView>
        <VFButton
          type="primary"
          title="call_me_back_button"
          onPress={returnToHome}
          style={[styles.stepButton, { marginTop: 32, marginHorizontal: 0 }]}
        />
      </View>
    )
  }


  return (
    <View style={styles.successContainer(theme)}>
      <View style={styles.contentWrapper}>
        <Icon
          name={Images.ic_WarningHiLight_Theme}
          size={120}
          resizeMode="contain"
          type="image"
          style={styles.image}
        />
        <View style={styles.textContainer}>
          <VfText
            i18nKey="call_me_back_error_title"
            size="h1"
            weight="bold"
            color={theme.colors.textColor}
          />
          <VfText
            i18nKey={callMeBackError || 'call_me_back_default_error'}
            size="h5"
            color={theme.colors.textColorTwo}
            style={styles.description}
          />
        </View>
      </View>
      <VFButton
        type="primary"
        title="call_me_back_button"
        onPress={returnToHome}
        style={styles.stepButton}
      />
    </View>
  )
}
ErrorStep.propTypes = {
  returnToHome: PropTypes.func,
  callMeBackError: PropTypes.string,
  theme: PropTypes.object,
}

function Success({
  callMeBackSuccess,
  returnToHome,
  theme,
}) {
  return (
    <View style={styles.successContainer(theme)}>
      <View style={styles.contentWrapper}>
        <Icon
          name={images.success_light}
          size={120}
          resizeMode="contain"
          type="image"
          style={styles.image}
        />
        <View style={styles.textContainer}>
          <VfText
            i18nKey={'call_me_back_success_title'}
            size="h1"
            weight="bold"
            color={theme.colors.textColor}
          />
          <VfText
            i18nKey={callMeBackSuccess?.description || 'call_me_back_success_description'}
            size="h5"
            color={theme.colors.textColorTwo}
            style={styles.description}
          />
        </View>
      </View>
      <VFButton
        type="primary"
        title="call_me_back_button"
        onPress={returnToHome}
        style={styles.stepButton}
      />
    </View>
  )
}
Success.propTypes = {
  callMeBackSuccess: PropTypes.object,
  returnToHome: PropTypes.func,
  theme: PropTypes.object,
}

const ActiveScreen = {
  home: Home,
  error: ErrorStep,
  success: Success,
}

const ModalScreen = {
  error: ErrorStep,
  success: Success,
  unOpened: <></>
}

function CallMeBack({
  onClose,
  navigateToHistory,
  loading,
  validityObject,
  userPhoneNumber,
  callMeBack,
  callMeBackError,
  callMeBackSuccess,
  callMeBackLoading,
  getHistory,
  theme,
  validatePhoneNumber,
  formatPhoneNumber,
}) {
  const [activeScreen, changeActiveScreen] = useState(activeScreens.home)
  const ShareStep = ActiveScreen[activeScreen]

  const [isModalVisible, setIsModalVisible] = useState(false)
  const [modalScreen, setModalScreen] = useState('unOpened')
  const ModalStep = ModalScreen[modalScreen]

  const inputRef = useRef()
  const [phoneNumber, setPhoneNumber] = useState('')
  const [isPhoneNumberError, setPhoneNumberError] = useState(false)

  const checkPhoneNumber = () => setPhoneNumberError(!validatePhoneNumber(phoneNumber))


  const selectFromContacts = () => {
    selectContactPhone().then(selection => {
      if (!selection) {
        return
      }
      inputRef.current?.setValue(formatPhoneNumber(selection.selectedPhone?.number))
      setPhoneNumber(formatPhoneNumber(selection.selectedPhone?.number.toString()))
      checkPhoneNumber()
      return
    })
  }

  const selectContact = () => {
    const permission = Platform.select({
      ios: PERMISSIONS.IOS.CONTACTS,
      android: PERMISSIONS.ANDROID.READ_CONTACTS,
    })
    check(permission)
      .then(result => {
        switch (result) {
          case RESULTS.UNAVAILABLE:
            break
          case RESULTS.DENIED:
            request(permission)
              .then((res) => {
                if (res === RESULTS.GRANTED) {
                  selectFromContacts()
                }
              })
              .catch(() => { })
            break
          case RESULTS.GRANTED:
            selectFromContacts()
            break
          case RESULTS.BLOCKED:
            openSettings().catch(() => null)
            break
        }
      })
      .catch(() => null)
  }

  const returnToHome = () => {
    setPhoneNumber('')
    if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
      setIsModalVisible(false)
      setModalScreen('unOpened')
    }
    else {
      changeActiveScreen(activeScreens.home)
    }
  }


  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <View>
        <ShareStep
          activeScreen={activeScreen}
          changeActiveScreen={changeActiveScreen}
          onClose={onClose}
          navigateToHistory={navigateToHistory}
          inputRef={inputRef}
          selectContact={selectContact}
          phoneNumber={phoneNumber}
          setPhoneNumber={setPhoneNumber}
          checkPhoneNumber={checkPhoneNumber}
          isPhoneNumberError={isPhoneNumberError}
          setPhoneNumberError={setPhoneNumberError}
          validityObject={validityObject}
          userPhoneNumber={userPhoneNumber}
          callMeBack={callMeBack}
          callMeBackError={callMeBackError}
          callMeBackLoading={callMeBackLoading}
          loading={loading}
          callMeBackSuccess={callMeBackSuccess}
          returnToHome={returnToHome}
          getHistory={getHistory}
          setIsModalVisible={setIsModalVisible}
          setModalScreen={setModalScreen}
          theme={theme}
          formatPhoneNumber={formatPhoneNumber}
        />
        <Modal
          isVisible={isModalVisible}
          backdropOpacity={0.5}
          onSwipeComplete={() => setIsModalVisible(false)}
          onBackdropPress={() => setIsModalVisible(false)}
          propagateSwipe
          hideModalContentWhileAnimating
          hardwareAccelerated
          backdropTransitionOutTiming={0}
          style={{
            justifyContent: 'flex-end',
            margin: '0 !important',
            minWidth: 1920,
            maxWidth: 1920,
          }}
        >
          <View
            style={{
              height: 'auto',
              minWidth: '730px',
              maxWidth: '730px',
              backgroundColor: theme.colors.quickActionGradientColors.secondary,
              margin: 'auto',
              padding: '20px',
              borderRadius: "7px",
            }}
            onStartShouldSetResponder={() => true}>
            <View
              style={{ flexDirection: 'row', justifyContent: 'space-between' }}
            >
              <VFText i18nKey='call_me_back_title' style={{ fontSize: 20, fontWeight: 700 }} />
              <Pressable
                onPress={() => setIsModalVisible(false)}
              >
                <Icon
                  name={images.close}
                  type="image"
                  resizeMode="contain"
                  size={24}
                  style={styles.closeIcon(Colors.dark_grey)}
                />
              </Pressable>
            </View>
            <ModalStep
              callMeBackError={callMeBackError}
              callMeBackLoading={callMeBackLoading}
              loading={loading}
              callMeBackSuccess={callMeBackSuccess}
              closeModa={() => setIsModalVisible(false)}
              returnToHome={() => setIsModalVisible(false)}
              theme={theme}
            />
          </View>
        </Modal>
      </View>
    )
  }


  return (
    <ShareStep
      activeScreen={activeScreen}
      changeActiveScreen={changeActiveScreen}
      onClose={onClose}
      navigateToHistory={navigateToHistory}
      inputRef={inputRef}
      selectContact={selectContact}
      phoneNumber={phoneNumber}
      setPhoneNumber={setPhoneNumber}
      checkPhoneNumber={checkPhoneNumber}
      isPhoneNumberError={isPhoneNumberError}
      setPhoneNumberError={setPhoneNumberError}
      validityObject={validityObject}
      userPhoneNumber={userPhoneNumber}
      callMeBack={callMeBack}
      callMeBackError={callMeBackError}
      callMeBackLoading={callMeBackLoading}
      loading={loading}
      callMeBackSuccess={callMeBackSuccess}
      returnToHome={returnToHome}
      getHistory={getHistory}
      theme={theme}
      formatPhoneNumber={formatPhoneNumber}
    />
  )
}
CallMeBack.defaultProps = {
  theme: {
    name: 'light',
    colors: LightThemeColors,
  }
}
CallMeBack.propTypes = {
  onClose: PropTypes.func,
  navigateToHistory: PropTypes.func,
  loading: PropTypes.bool,
  validityObject: PropTypes.object,
  userPhoneNumber: PropTypes.string,
  callMeBack: PropTypes.func,
  callMeBackError: PropTypes.string,
  callMeBackSuccess: PropTypes.object,
  callMeBackLoading: PropTypes.bool,
  getHistory: PropTypes.func,
  theme: PropTypes.object,
  validatePhoneNumber: PropTypes.func,
  formatPhoneNumber: PropTypes.func,
}

export default withTheme(CallMeBack)
